import React from 'react';

import FieldLabel from './FieldLabel';
import FieldStatusText from './FieldStatusText';
import FormGroup from './FormGroup';
import RadioSelect from './RadioSelect';

type Props = {
    name: string;
    label?: string;
    placeholder?: string;
    value: string;
    options: Record<string, string>;
    onChange: (ev: any) => void;
    autoFocus?: boolean;
    error?: string;
};

const FormRadioSelect: React.FC<Props> = (props) => (
    <FormGroup itemsSpacing={5}>
        <FieldLabel>{props.label}</FieldLabel>
        <RadioSelect style={{ fontSize: '1.6rem' }} {...props} />
        <FieldStatusText status="error">{props.error}</FieldStatusText>
    </FormGroup>
);

export default FormRadioSelect;
